<template>
  <v-container fluid>

    <v-layout>
      <div class="img-services-container">
        <div class="pitch-services">
          <h2 class="ma-0 white--text" v-if="$vuetify.breakpoint.smAndUp">Nous vous conseillons et nous défendons les relations individuelles<br />
            en droit du travail et en droit de la sécurité sociale<br />
              <b>pour faire pencher la balance de votre côté.</b></h2>

          <h2 class="ma-0 white--text" v-else>Nous vous conseillons et nous défendons les relations individuelles
            en droit du travail et en droit de la sécurité sociale<br />
              <b>pour faire pencher la balance de votre côté.</b></h2>
        </div>
      </div>
    </v-layout>

    <v-container fluid grid-list-xl class="services-list">

      <v-flex xs12 class="mt-4 mb-3 h1-container">
        <!-- <h1 class="text-xs-center text-uppercase">Expertise en droit social</h1> -->
        <h1 class="text-xs-center text-uppercase">Un panel de services répondant à vos questions</h1>
        <div class="h1-background" />
      </v-flex>

      <v-layout row wrap class="px-5">
        <v-flex xs12 sm6 md4 class="pl-4">
          <img src="@/assets/contract-primary.svg" />
          <h5 class="primary--text text-uppercase mt-1">Exécution du contrat de travail</h5>
          <p class="my-2">Formation, entretien annuel, évolution professionnelle, modification du contrat de travail, droit disciplinaire.</p>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pl-4">
          <img src="@/assets/talk-bubbles-primary.svg" />
          <h5 class="primary--text text-uppercase mt-1">Négociations collectives</h5>
          <p class="my-2">Élections de représentants du personnel, négociation, accords collectifs et accords d’entreprise.</p>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pl-4">
          <img src="@/assets/unlink-primary.svg" />
          <h5 class="primary--text text-uppercase mt-1">Rupture du contrat de travail</h5>
          <p class="my-2">Licenciement, rupture conventionnelle, prise d’acte, résiliation judiciaire, départs négociés, transactions.</p>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pl-4">
          <img src="@/assets/id-badge-primary.svg" />
          <h5 class="primary--text text-uppercase mt-1">Recrutement</h5>
          <p class="my-2">Choix du contrat de travail.</p>
          <p>Rédaction des clauses (rémunération, objectifs, durée du travail, non concurrence,
              délégation de pouvoirs).</p>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pl-4">
          <img src="@/assets/bank-line-primary.svg" />
          <h5 class="primary--text text-uppercase mt-1">Assistance et représentation</h5>
          <p class="my-2">Intervention amiable devant l’inspection du travail, l’URSSAF, la CPAM.</p>
          <p class="my-2">Précontentieux et contentieux. </p>
          <p>Défense devant la Cour d’Appel en matière de TASS et TCI.</p>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pl-4">
          <img src="@/assets/ambulance-primary.svg" />
          <h5 class="primary--text text-uppercase mt-1">Accident du travail / Maladie pro</h5>
          <p class="my-2">Réserves, contestation, saisine de la commission de recours amiable.</p>
          <p>Tribunal des Affaires de Sécurité Sociale, Tribunal du Contentieux de l’Incapacité, Cour d’Appel.</p>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pl-4">
          <img src="@/assets/shield-check-primary.svg" />
          <h5 class="primary--text text-uppercase mt-1">Protection du chef d'entreprise</h5>
          <p class="my-2">Contestation de la responsabilité pénale du chef d’entreprise, défense contre la faute inexcusable.</p>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pl-4">
          <img src="@/assets/accessibility-primary.svg" />
          <h5 class="primary--text text-uppercase mt-1">Services de santé du travail</h5>
          <p class="my-2">Inaptitude, invalidité, réclamation et contestation,  rente.</p>
          <p>Contestation sur l’imputabilité à l’entreprise ou du chef d’entreprise.</p>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pl-4">
          <img src="@/assets/ruler-pencil-primary.svg" />
          <h5 class="primary--text text-uppercase mt-1">Formation sur mesure</h5>
          <p class="my-2">Assurée en interne pour l’entrepreneur, le(s) adjoint(s), le(s) collaborateur(s). (En individuel ou en collectif).</p>
        </v-flex>
        <v-flex xs12 sm6 md4 class="pl-4" v-if="$vuetify.breakpoint.smAndDown">
          <h5 class="secondary--text title text-xs-center">
            <b>“ Les économies d’aujourd’hui font les investissements de demain. ”</b>
          </h5>
        </v-flex>
      </v-layout>

    </v-container>
    <v-layout column :class="$vuetify.breakpoint.smAndDown ? 'px-4' : 'px80'">
      <v-flex xs12 class="mediation-container">
        <h1 class="text-uppercase px-0 py-2">La médiation professionnelle</h1>
        <p>Une discipline à part entière pour résoudre les conflits et prévenir les situations conflictuelles.</p>
        <p>Une profession éthique : <b class="primary--text">un médiateur</b>, une mission, un résultat.</p>
        <p><i><b>La médiation est la seule approche des litiges, crises et conflits par laquelle les parties aboutissent à une libre décision et une solution élaborée par elles-mêmes qui ne leur a pas été imposée.</b></i></p>
        <p class="primary--text"><i><b>MC Consultant vous accompagne dans toutes les situations avec une approche rationnelle, impartiale et une culture de l’altérité.</b></i></p>
      </v-flex>
    </v-layout>

    <v-flex xs12 v-if="!$vuetify.breakpoint.smAndDown" class="secondary--text title
        font-weight-medium white--text text-xs-center mb-5">
      <b>“ Les économies d’aujourd’hui font les investissements de demain. ”</b>
    </v-flex>
    <contact-section />
  </v-container>
</template>

<script>
import ContactSection from '@/components/sections/ContactSection.vue'

export default {
  name: 'services',
  components: {
    ContactSection
  },
  created () {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="stylus">
.img-services-container
  width: 100%
  height: 450px
  background: url('../../public/services.png') no-repeat center 75%
  background-size: cover

.pitch-services
  display: flex
  justify-content: center
  align-items: center
  width: 100%
  height: 450px
  background-color: rgba(0, 0, 0, 0.7)

.pitch-services h2
  font-weight: normal
  font-size: 1.8rem
  line-height: 3rem

.services-list h1
  font-size: 1.8rem
  padding: 0 24px
  background-color: #FFF
  z-index: 5

.services-list .h1-container
  display: flex
  justify-content: center

.services-list .h1-container::after
  position: absolute
  left: 0
  content: ''
  display: block
  margin-top: 18px
  width: 50%
  height: 5px
  background-color: #CC5803
  z-index: 0

.services-list .h1-container::before
  position: absolute
  right: 0
  content: ''
  display: block
  margin-top: 18px
  width: 50%
  height: 5px
  background-color: #CDD0D5
  z-index: 1

.services-list img
  width: 32px
  height: 32px

.services-list p
  font-size: 13px

.mediation-container
  border: 4px solid #CC5803
  margin: 36px 0
  padding: 18px 48px !important

.mediation-container h1
  font-size: 1.8rem

.mediation-container p
  padding: 8px 0
  font-size: 16px

/* Style for medium devices */

.mdOnly .services-list h1,
.mdOnly .mediation-container h1
  font-size: 1.6rem

.mdOnly .services-list .h1-container::after,
.mdOnly .services-list .h1-container::before
  margin-top: 15px

.mediation-container
  margin: 36px 0 48px 0

/* Style for small devices */
.smOnly .img-services-container
  height: 350px

.smOnly .pitch-services
  height: 350px

.smOnly .pitch-services h2
  font-size: 1.1rem
  line-height: 2rem
  padding: 0 24px

.smOnly .services-list h1,
.smOnly .mediation-container h1
  font-size: 1.1rem

.smOnly .services-list h5
  font-size: 0.75rem
  margin-top: 36px

.smOnly .services-list .title
  font-size: 1.2rem !important
  line-height: 1.6rem !important
  letter-spacing: -0.2px !important

.smOnly .services-list .h1-container::after,
.smOnly .services-list .h1-container::before
  margin-top: 8px
  height: 4px

.smOnly .mediation-container
  margin: 24px 32px 48px 32px
  padding: 16px 32px !important

.smOnly .mediation-container p
  font-size: 13px

/* Style for extra-small devices */
.xsOnly .img-services-container
  height: 300px

.xsOnly .pitch-services
  height: 300px

.xsOnly .pitch-services h2
  font-size: 1rem
  line-height: 2rem
  padding: 0 24px

.xsOnly .services-list .flex
  padding: 16px 0 !important
  text-align: center !important

.xsOnly .services-list h1
  font-size: 1.1rem
  padding: 0 16px !important

.xsOnly .services-list h5
  font-size: 0.75rem
  margin: 0 !important

.xsOnly .services-list .title
  font-size: 1.2rem !important
  line-height: 1.6rem !important

.xsOnly .services-list .h1-container::after,
.xsOnly .services-list .h1-container::before
  margin-top: 8px

.xsOnly .mediation-container
  border: 3px solid #CC5803
  margin: 24px 0 48px 0
  padding: 16px 20px !important

.xsOnly .mediation-container h1
  font-size: 1.1rem

.xsOnly .mediation-container p
  font-size: 13px
</style>


